import { useSearchParams } from "react-router-dom";
import "./linkedin-invite.css";

function LinkedInInvitePage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const success = searchParams.get("success");

  const handleConnect = () => {
    if (!token) return;
    window.location.href =
      process.env.REACT_APP_BACKEND_URL + "/api/auth/linkedin?token=" + encodeURIComponent(token);
  };

  if (success === "true") {
    return (
      <div className="linkedin-invite-page">
        <div className="linkedin-invite-card">
          <img src="/images/logo.png" alt="Mako" className="linkedin-invite-logo" />
          <h1 className="linkedin-invite-heading">You're connected!</h1>
          <p className="linkedin-invite-body">
            Your LinkedIn account has been successfully linked. You can close this page now.
          </p>
        </div>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="linkedin-invite-page">
        <div className="linkedin-invite-card">
          <img src="/images/logo.png" alt="Mako" className="linkedin-invite-logo" />
          <h1 className="linkedin-invite-heading">Invalid invite</h1>
          <p className="linkedin-invite-body">
            This invitation link is missing or expired. Please ask the person who invited you to
            send a new one.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="linkedin-invite-page">
      <div className="linkedin-invite-card">
        <img src="/images/logo.png" alt="Mako" className="linkedin-invite-logo" />
        <h1 className="linkedin-invite-heading">Connect your LinkedIn</h1>
        <p className="linkedin-invite-body">
          Someone has invited you to link your LinkedIn account with{" "}
          <strong>Mako</strong> — an AI-powered content engine that helps thought leaders
          publish high-quality LinkedIn posts effortlessly.
        </p>
        <p className="linkedin-invite-body">
          By connecting, Mako will be able to draft and schedule posts on your behalf,
          tailored to your unique voice and audience. You stay in full control — nothing
          is ever published without your approval.
        </p>
        <div className="linkedin-invite-cta" onClick={handleConnect}>
          Connect your LinkedIn account
        </div>
        <p className="linkedin-invite-footnote">
          You'll be redirected to LinkedIn to authorize access. You can revoke this
          connection at any time.
        </p>
      </div>
    </div>
  );
}

export default LinkedInInvitePage;
